import React from "react";
import { memo } from 'react';
import { Draggable } from 'react-beautiful-dnd';

const SarasDnDCard = memo(({ index, rowKey, children, isSortMode})=>{
    return (
        <>
            <Draggable key={rowKey} draggableId={rowKey} isDragDisabled={!(isSortMode === undefined ? true : isSortMode)} index={index}>
            {(provided, snapshot) => (
                <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                >
                    {children}
                </div>
            )}
            </Draggable>
        </>
        );
});

export default SarasDnDCard;
